import * as React from 'react';
import {useCreateCourseMutation, useLanguagesQuery} from "../../../../types.d";
import {Field} from "@intelingu/core/components/form/Field";
import {SelectList} from "../../../partials/form/elements/SelectList";
import {FormGroup} from "../../../partials/form/elements/FormGroup";
import {Form} from "@intelingu/core/components/form/Form";
import {SubmitButton} from "../../../partials/form/elements/SubmitButton";
import {Link} from "react-router-dom";

class Validator {}

export const CreateCoursePage = props => {
    const languages = useLanguagesQuery();

    const [ createCourse, { data: createdCourse } ] = useCreateCourseMutation();

    if (!languages || !languages.data) {
        return null;
    }

    const languagesOptions = languages.data.languages.map(item => ({
        label: item.name,
        value: item.id
    }));

    return <div className={'index-wrapper'}>
        <div className={'index-page'}>
            <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                    <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                    <li className="breadcrumb-item active" aria-current="page">
                        Create course
                    </li>
                </ol>
            </nav>

            <Form validator={Validator} onSubmit={async (data, done) => {
                const source = languages.data.languages.filter(item => item.id === Number(data.sourceLanguage))[0];
                const translation = languages.data.languages.filter(item => item.id === Number(data.translationLanguage))[0];

                data.postTitle = `${source.name} -> ${translation.name}`;

                await createCourse({
                    variables: {
                        input: data
                    }
                });

                done();
            }}>
                <FormGroup label={'Source language'}>
                    <Field
                        name={'sourceLanguage'}
                        render={props => <SelectList options={languagesOptions} {...props} />} />
                </FormGroup>

                <FormGroup label={'Translation language'}>
                    <Field
                        name={'translationLanguage'}
                        render={props => <SelectList options={languagesOptions} {...props} />} />
                </FormGroup>

                <div className={'col-12'}>
                    <Field submit render={props => <SubmitButton {...props}>Done</SubmitButton>} />
                </div>
            </Form>
        </div>
    </div>
};
